<template>
	<div class="home">
		<v-img :aspect-ratio="83/24" :src="require('../assets/banner.jpg')">
			<v-row align="center" justify='center' class="lightbox white--text pa-2 fill-height">
				<v-col cols="12">
					<h2 class="hidden-sm-and-down subheading">Life Fun</h2>
					<h2 class="hidden-sm-and-down subheading">Professional and Intelligent Test Compilation</h2>
					<p class="hidden-md-and-up subheading">&nbsp;</p>
					<p class="hidden-md-and-up subheading">Professional and Intelligent Test Compilation</p>
				</v-col>
			</v-row>
		</v-img>
		<div>
			<v-row no-gutters>
				<v-col lg="3" md="6" sm="12">
					<v-img :src="require('../assets/home-124226881.jpg')"></v-img>
				</v-col>
				<v-col lg="3" md="6" sm="12">
					<v-img :src="require('../assets/home-124226882.jpg')"></v-img>
				</v-col>
				<v-col lg="3" md="6" sm="12">
					<v-img :src="require('../assets/home-124226883.jpg')"></v-img>
				</v-col>
				<v-col lg="3" md="6" sm="12">
					<v-img :src="require('../assets/home-124226884.jpg')"></v-img>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'home',
		components: {}
	}
</script>